<mat-icon
  *ngIf="presentation as statusPresentation"
  [matTooltip]="statusPresentation.tooltip"
  [ngClass]="statusPresentation.cssClass"
  >{{ statusPresentation.icon }}</mat-icon
>
